export default class OperatorService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('brands/' + id, params)
	}

	createEntity(params){
		return this.apiService.callPost('brands', params);
	}

	getEntities(params) {
		return this.apiService.callGet('brands', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('brands/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('brands/' + id, params)
	}

	// SEARCH
	searchBrandsForRecipients(params) {
		return this.apiService.callGet('brands_search', params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('brands/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BrandService.js